export default __webpack_public_path__ + "static/media/icon-192x192.4b30ec33.png";